/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseVirtualBrandsInner } from './GetConfig200ResponseVirtualBrandsInner';
import {
    GetConfig200ResponseVirtualBrandsInnerFromJSON,
    GetConfig200ResponseVirtualBrandsInnerFromJSONTyped,
    GetConfig200ResponseVirtualBrandsInnerToJSON,
    GetConfig200ResponseVirtualBrandsInnerToJSONTyped,
} from './GetConfig200ResponseVirtualBrandsInner';
import type { GetConfig200ResponsePrintersInner } from './GetConfig200ResponsePrintersInner';
import {
    GetConfig200ResponsePrintersInnerFromJSON,
    GetConfig200ResponsePrintersInnerFromJSONTyped,
    GetConfig200ResponsePrintersInnerToJSON,
    GetConfig200ResponsePrintersInnerToJSONTyped,
} from './GetConfig200ResponsePrintersInner';
import type { GetConfig200ResponseLastProducts } from './GetConfig200ResponseLastProducts';
import {
    GetConfig200ResponseLastProductsFromJSON,
    GetConfig200ResponseLastProductsFromJSONTyped,
    GetConfig200ResponseLastProductsToJSON,
    GetConfig200ResponseLastProductsToJSONTyped,
} from './GetConfig200ResponseLastProducts';
import type { GetConfig200ResponseOrganizationConfig } from './GetConfig200ResponseOrganizationConfig';
import {
    GetConfig200ResponseOrganizationConfigFromJSON,
    GetConfig200ResponseOrganizationConfigFromJSONTyped,
    GetConfig200ResponseOrganizationConfigToJSON,
    GetConfig200ResponseOrganizationConfigToJSONTyped,
} from './GetConfig200ResponseOrganizationConfig';
import type { GetConfig200ResponseDataphoneConfigsInner } from './GetConfig200ResponseDataphoneConfigsInner';
import {
    GetConfig200ResponseDataphoneConfigsInnerFromJSON,
    GetConfig200ResponseDataphoneConfigsInnerFromJSONTyped,
    GetConfig200ResponseDataphoneConfigsInnerToJSON,
    GetConfig200ResponseDataphoneConfigsInnerToJSONTyped,
} from './GetConfig200ResponseDataphoneConfigsInner';
import type { GetConfig200ResponseTillsCashInner } from './GetConfig200ResponseTillsCashInner';
import {
    GetConfig200ResponseTillsCashInnerFromJSON,
    GetConfig200ResponseTillsCashInnerFromJSONTyped,
    GetConfig200ResponseTillsCashInnerToJSON,
    GetConfig200ResponseTillsCashInnerToJSONTyped,
} from './GetConfig200ResponseTillsCashInner';
import type { GetConfig200ResponseReservations } from './GetConfig200ResponseReservations';
import {
    GetConfig200ResponseReservationsFromJSON,
    GetConfig200ResponseReservationsFromJSONTyped,
    GetConfig200ResponseReservationsToJSON,
    GetConfig200ResponseReservationsToJSONTyped,
} from './GetConfig200ResponseReservations';
import type { GetConfig200ResponseTills } from './GetConfig200ResponseTills';
import {
    GetConfig200ResponseTillsFromJSON,
    GetConfig200ResponseTillsFromJSONTyped,
    GetConfig200ResponseTillsToJSON,
    GetConfig200ResponseTillsToJSONTyped,
} from './GetConfig200ResponseTills';
import type { GetConfig200ResponseEmployees } from './GetConfig200ResponseEmployees';
import {
    GetConfig200ResponseEmployeesFromJSON,
    GetConfig200ResponseEmployeesFromJSONTyped,
    GetConfig200ResponseEmployeesToJSON,
    GetConfig200ResponseEmployeesToJSONTyped,
} from './GetConfig200ResponseEmployees';
import type { GetConfig200ResponseReservationDurations } from './GetConfig200ResponseReservationDurations';
import {
    GetConfig200ResponseReservationDurationsFromJSON,
    GetConfig200ResponseReservationDurationsFromJSONTyped,
    GetConfig200ResponseReservationDurationsToJSON,
    GetConfig200ResponseReservationDurationsToJSONTyped,
} from './GetConfig200ResponseReservationDurations';
import type { GetConfig200ResponseTerminalsInner } from './GetConfig200ResponseTerminalsInner';
import {
    GetConfig200ResponseTerminalsInnerFromJSON,
    GetConfig200ResponseTerminalsInnerFromJSONTyped,
    GetConfig200ResponseTerminalsInnerToJSON,
    GetConfig200ResponseTerminalsInnerToJSONTyped,
} from './GetConfig200ResponseTerminalsInner';
import type { GetConfig200ResponseCompany } from './GetConfig200ResponseCompany';
import {
    GetConfig200ResponseCompanyFromJSON,
    GetConfig200ResponseCompanyFromJSONTyped,
    GetConfig200ResponseCompanyToJSON,
    GetConfig200ResponseCompanyToJSONTyped,
} from './GetConfig200ResponseCompany';
import type { GetConfig200ResponsePaymentMethodsConfigInner } from './GetConfig200ResponsePaymentMethodsConfigInner';
import {
    GetConfig200ResponsePaymentMethodsConfigInnerFromJSON,
    GetConfig200ResponsePaymentMethodsConfigInnerFromJSONTyped,
    GetConfig200ResponsePaymentMethodsConfigInnerToJSON,
    GetConfig200ResponsePaymentMethodsConfigInnerToJSONTyped,
} from './GetConfig200ResponsePaymentMethodsConfigInner';
import type { GetConfig200ResponseKassensichvInfo } from './GetConfig200ResponseKassensichvInfo';
import {
    GetConfig200ResponseKassensichvInfoFromJSON,
    GetConfig200ResponseKassensichvInfoFromJSONTyped,
    GetConfig200ResponseKassensichvInfoToJSON,
    GetConfig200ResponseKassensichvInfoToJSONTyped,
} from './GetConfig200ResponseKassensichvInfo';
import type { GetConfig200ResponseAdyenDataphonesInner } from './GetConfig200ResponseAdyenDataphonesInner';
import {
    GetConfig200ResponseAdyenDataphonesInnerFromJSON,
    GetConfig200ResponseAdyenDataphonesInnerFromJSONTyped,
    GetConfig200ResponseAdyenDataphonesInnerToJSON,
    GetConfig200ResponseAdyenDataphonesInnerToJSONTyped,
} from './GetConfig200ResponseAdyenDataphonesInner';
import type { GetConfig200ResponseLegalEntity } from './GetConfig200ResponseLegalEntity';
import {
    GetConfig200ResponseLegalEntityFromJSON,
    GetConfig200ResponseLegalEntityFromJSONTyped,
    GetConfig200ResponseLegalEntityToJSON,
    GetConfig200ResponseLegalEntityToJSONTyped,
} from './GetConfig200ResponseLegalEntity';
import type { GetConfig200ResponseTaxRate } from './GetConfig200ResponseTaxRate';
import {
    GetConfig200ResponseTaxRateFromJSON,
    GetConfig200ResponseTaxRateFromJSONTyped,
    GetConfig200ResponseTaxRateToJSON,
    GetConfig200ResponseTaxRateToJSONTyped,
} from './GetConfig200ResponseTaxRate';
import type { GetConfig200ResponseWorkingTime } from './GetConfig200ResponseWorkingTime';
import {
    GetConfig200ResponseWorkingTimeFromJSON,
    GetConfig200ResponseWorkingTimeFromJSONTyped,
    GetConfig200ResponseWorkingTimeToJSON,
    GetConfig200ResponseWorkingTimeToJSONTyped,
} from './GetConfig200ResponseWorkingTime';
import type { GetConfig200ResponseShipmentProviders } from './GetConfig200ResponseShipmentProviders';
import {
    GetConfig200ResponseShipmentProvidersFromJSON,
    GetConfig200ResponseShipmentProvidersFromJSONTyped,
    GetConfig200ResponseShipmentProvidersToJSON,
    GetConfig200ResponseShipmentProvidersToJSONTyped,
} from './GetConfig200ResponseShipmentProviders';

/**
 * 
 * @export
 * @interface GetConfig200Response
 */
export interface GetConfig200Response {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationName: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationAddress: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationCountryCode: GetConfig200ResponseLocationCountryCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    billCopies: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    timeoutSeconds?: number | null;
    /**
     * 
     * @type {GetConfig200ResponseWorkingTime}
     * @memberof GetConfig200Response
     */
    workingTime: GetConfig200ResponseWorkingTime;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    autoprintBills: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    autoprintKitchenOrders: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    autoprintReceipts: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    defaultKitchenPrinter?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    defaultBillPrinter?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    controlPrinter?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    onlyMasterPrinting: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    enableKitchenOrders: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    showTakeAwayTabPopup: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    showProductImages: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    blindTill: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    locationBrandId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    tabOrdering?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    autoprintQrKitchenOrders?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    legalEntityId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    fastMode: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    fastModeHome: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    fastModeTakeaway: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    ticketInfo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    googlePlaceId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    showLanguageSelector?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    restaurantAutoprint?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    takeawayAutoprint?: boolean | null;
    /**
     * 
     * @type {Array<GetConfig200ResponsePrintersInner>}
     * @memberof GetConfig200Response
     */
    printers: Array<GetConfig200ResponsePrintersInner>;
    /**
     * 
     * @type {GetConfig200ResponseTills}
     * @memberof GetConfig200Response
     */
    tills: GetConfig200ResponseTills;
    /**
     * 
     * @type {Array<GetConfig200ResponseTillsCashInner>}
     * @memberof GetConfig200Response
     */
    cashTills: Array<GetConfig200ResponseTillsCashInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetConfig200Response
     */
    paymentMethods: Array<string>;
    /**
     * 
     * @type {Array<GetConfig200ResponsePaymentMethodsConfigInner>}
     * @memberof GetConfig200Response
     */
    paymentMethodsConfig: Array<GetConfig200ResponsePaymentMethodsConfigInner>;
    /**
     * 
     * @type {Array<GetConfig200ResponseDataphoneConfigsInner>}
     * @memberof GetConfig200Response
     */
    dataphoneConfigs: Array<GetConfig200ResponseDataphoneConfigsInner>;
    /**
     * 
     * @type {Array<GetConfig200ResponseTerminalsInner>}
     * @memberof GetConfig200Response
     */
    terminals: Array<GetConfig200ResponseTerminalsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    isHotel: boolean;
    /**
     * 
     * @type {GetConfig200ResponseLegalEntity}
     * @memberof GetConfig200Response
     */
    legalEntity: GetConfig200ResponseLegalEntity;
    /**
     * 
     * @type {GetConfig200ResponseCompany}
     * @memberof GetConfig200Response
     */
    company: GetConfig200ResponseCompany;
    /**
     * 
     * @type {GetConfig200ResponseEmployees}
     * @memberof GetConfig200Response
     */
    employees?: GetConfig200ResponseEmployees;
    /**
     * 
     * @type {Array<GetConfig200ResponseVirtualBrandsInner>}
     * @memberof GetConfig200Response
     */
    virtualBrands: Array<GetConfig200ResponseVirtualBrandsInner>;
    /**
     * 
     * @type {GetConfig200ResponseReservations}
     * @memberof GetConfig200Response
     */
    reservations: GetConfig200ResponseReservations;
    /**
     * 
     * @type {GetConfig200ResponseReservationDurations}
     * @memberof GetConfig200Response
     */
    reservationDurations?: GetConfig200ResponseReservationDurations;
    /**
     * 
     * @type {GetConfig200ResponseOrganizationConfig}
     * @memberof GetConfig200Response
     */
    organizationConfig: GetConfig200ResponseOrganizationConfig;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    preparationMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200Response
     */
    schedulingMarginMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    deliveryTillId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    deliveryPrinterId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200Response
     */
    shipmentProvider?: string | null;
    /**
     * 
     * @type {GetConfig200ResponseShipmentProviders}
     * @memberof GetConfig200Response
     */
    shipmentProviders: GetConfig200ResponseShipmentProviders;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    manualShipment?: boolean;
    /**
     * 
     * @type {GetConfig200ResponseLastProducts}
     * @memberof GetConfig200Response
     */
    lastProducts: GetConfig200ResponseLastProducts;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    lastProductPosEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    lastProductBookingsEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    lastProductAttendanceEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    lastProductStockEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200Response
     */
    waitForMetaBeforePrintingBill: boolean;
    /**
     * 
     * @type {Array<GetConfig200ResponseAdyenDataphonesInner>}
     * @memberof GetConfig200Response
     */
    adyenDataphones: Array<GetConfig200ResponseAdyenDataphonesInner>;
    /**
     * 
     * @type {GetConfig200ResponseKassensichvInfo}
     * @memberof GetConfig200Response
     */
    kassensichvInfo: GetConfig200ResponseKassensichvInfo | null;
    /**
     * 
     * @type {GetConfig200ResponseTaxRate}
     * @memberof GetConfig200Response
     */
    taxRate: GetConfig200ResponseTaxRate;
}


/**
 * @export
 */
export const GetConfig200ResponseLocationCountryCodeEnum = {
    Es: 'ES',
    Mx: 'MX',
    Ad: 'AD',
    De: 'DE',
    Pe: 'PE',
    Co: 'CO',
    Ar: 'AR',
    Cl: 'CL'
} as const;
export type GetConfig200ResponseLocationCountryCodeEnum = typeof GetConfig200ResponseLocationCountryCodeEnum[keyof typeof GetConfig200ResponseLocationCountryCodeEnum];


/**
 * Check if a given object implements the GetConfig200Response interface.
 */
export function instanceOfGetConfig200Response(value: object): value is GetConfig200Response {
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('locationAddress' in value) || value['locationAddress'] === undefined) return false;
    if (!('locationCountryCode' in value) || value['locationCountryCode'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('billCopies' in value) || value['billCopies'] === undefined) return false;
    if (!('workingTime' in value) || value['workingTime'] === undefined) return false;
    if (!('autoprintBills' in value) || value['autoprintBills'] === undefined) return false;
    if (!('autoprintKitchenOrders' in value) || value['autoprintKitchenOrders'] === undefined) return false;
    if (!('autoprintReceipts' in value) || value['autoprintReceipts'] === undefined) return false;
    if (!('onlyMasterPrinting' in value) || value['onlyMasterPrinting'] === undefined) return false;
    if (!('enableKitchenOrders' in value) || value['enableKitchenOrders'] === undefined) return false;
    if (!('showTakeAwayTabPopup' in value) || value['showTakeAwayTabPopup'] === undefined) return false;
    if (!('showProductImages' in value) || value['showProductImages'] === undefined) return false;
    if (!('blindTill' in value) || value['blindTill'] === undefined) return false;
    if (!('fastMode' in value) || value['fastMode'] === undefined) return false;
    if (!('fastModeHome' in value) || value['fastModeHome'] === undefined) return false;
    if (!('fastModeTakeaway' in value) || value['fastModeTakeaway'] === undefined) return false;
    if (!('printers' in value) || value['printers'] === undefined) return false;
    if (!('tills' in value) || value['tills'] === undefined) return false;
    if (!('cashTills' in value) || value['cashTills'] === undefined) return false;
    if (!('paymentMethods' in value) || value['paymentMethods'] === undefined) return false;
    if (!('paymentMethodsConfig' in value) || value['paymentMethodsConfig'] === undefined) return false;
    if (!('dataphoneConfigs' in value) || value['dataphoneConfigs'] === undefined) return false;
    if (!('terminals' in value) || value['terminals'] === undefined) return false;
    if (!('isHotel' in value) || value['isHotel'] === undefined) return false;
    if (!('legalEntity' in value) || value['legalEntity'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('virtualBrands' in value) || value['virtualBrands'] === undefined) return false;
    if (!('reservations' in value) || value['reservations'] === undefined) return false;
    if (!('organizationConfig' in value) || value['organizationConfig'] === undefined) return false;
    if (!('shipmentProviders' in value) || value['shipmentProviders'] === undefined) return false;
    if (!('lastProducts' in value) || value['lastProducts'] === undefined) return false;
    if (!('waitForMetaBeforePrintingBill' in value) || value['waitForMetaBeforePrintingBill'] === undefined) return false;
    if (!('adyenDataphones' in value) || value['adyenDataphones'] === undefined) return false;
    if (!('kassensichvInfo' in value) || value['kassensichvInfo'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseFromJSON(json: any): GetConfig200Response {
    return GetConfig200ResponseFromJSONTyped(json, false);
}

export function GetConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'locationName': json['locationName'],
        'locationAddress': json['locationAddress'],
        'locationPhoneNumber': json['locationPhoneNumber'] == null ? undefined : json['locationPhoneNumber'],
        'locationCountryCode': json['locationCountryCode'],
        'currencyCode': json['currencyCode'],
        'billCopies': json['billCopies'],
        'timeoutSeconds': json['timeoutSeconds'] == null ? undefined : json['timeoutSeconds'],
        'workingTime': GetConfig200ResponseWorkingTimeFromJSON(json['workingTime']),
        'autoprintBills': json['autoprintBills'],
        'autoprintKitchenOrders': json['autoprintKitchenOrders'],
        'autoprintReceipts': json['autoprintReceipts'],
        'language': json['language'] == null ? undefined : json['language'],
        'defaultKitchenPrinter': json['defaultKitchenPrinter'] == null ? undefined : json['defaultKitchenPrinter'],
        'defaultBillPrinter': json['defaultBillPrinter'] == null ? undefined : json['defaultBillPrinter'],
        'controlPrinter': json['controlPrinter'] == null ? undefined : json['controlPrinter'],
        'onlyMasterPrinting': json['onlyMasterPrinting'],
        'enableKitchenOrders': json['enableKitchenOrders'],
        'showTakeAwayTabPopup': json['showTakeAwayTabPopup'],
        'showProductImages': json['showProductImages'],
        'blindTill': json['blindTill'],
        'locationBrandId': json['locationBrandId'] == null ? undefined : json['locationBrandId'],
        'tabOrdering': json['tabOrdering'] == null ? undefined : json['tabOrdering'],
        'autoprintQrKitchenOrders': json['autoprintQrKitchenOrders'] == null ? undefined : json['autoprintQrKitchenOrders'],
        'legalEntityId': json['legalEntityId'] == null ? undefined : json['legalEntityId'],
        'fastMode': json['fastMode'],
        'fastModeHome': json['fastModeHome'],
        'fastModeTakeaway': json['fastModeTakeaway'],
        'ticketInfo': json['ticketInfo'] == null ? undefined : json['ticketInfo'],
        'googlePlaceId': json['googlePlaceId'] == null ? undefined : json['googlePlaceId'],
        'showLanguageSelector': json['showLanguageSelector'] == null ? undefined : json['showLanguageSelector'],
        'restaurantAutoprint': json['restaurantAutoprint'] == null ? undefined : json['restaurantAutoprint'],
        'takeawayAutoprint': json['takeawayAutoprint'] == null ? undefined : json['takeawayAutoprint'],
        'printers': ((json['printers'] as Array<any>).map(GetConfig200ResponsePrintersInnerFromJSON)),
        'tills': GetConfig200ResponseTillsFromJSON(json['tills']),
        'cashTills': ((json['cashTills'] as Array<any>).map(GetConfig200ResponseTillsCashInnerFromJSON)),
        'paymentMethods': json['paymentMethods'],
        'paymentMethodsConfig': ((json['paymentMethodsConfig'] as Array<any>).map(GetConfig200ResponsePaymentMethodsConfigInnerFromJSON)),
        'dataphoneConfigs': ((json['dataphoneConfigs'] as Array<any>).map(GetConfig200ResponseDataphoneConfigsInnerFromJSON)),
        'terminals': ((json['terminals'] as Array<any>).map(GetConfig200ResponseTerminalsInnerFromJSON)),
        'isHotel': json['isHotel'],
        'legalEntity': GetConfig200ResponseLegalEntityFromJSON(json['legalEntity']),
        'company': GetConfig200ResponseCompanyFromJSON(json['company']),
        'employees': json['employees'] == null ? undefined : GetConfig200ResponseEmployeesFromJSON(json['employees']),
        'virtualBrands': ((json['virtualBrands'] as Array<any>).map(GetConfig200ResponseVirtualBrandsInnerFromJSON)),
        'reservations': GetConfig200ResponseReservationsFromJSON(json['reservations']),
        'reservationDurations': json['reservationDurations'] == null ? undefined : GetConfig200ResponseReservationDurationsFromJSON(json['reservationDurations']),
        'organizationConfig': GetConfig200ResponseOrganizationConfigFromJSON(json['organizationConfig']),
        'preparationMinutes': json['preparationMinutes'] == null ? undefined : json['preparationMinutes'],
        'schedulingMarginMinutes': json['schedulingMarginMinutes'] == null ? undefined : json['schedulingMarginMinutes'],
        'deliveryTillId': json['deliveryTillId'] == null ? undefined : json['deliveryTillId'],
        'deliveryPrinterId': json['deliveryPrinterId'] == null ? undefined : json['deliveryPrinterId'],
        'shipmentProvider': json['shipmentProvider'] == null ? undefined : json['shipmentProvider'],
        'shipmentProviders': GetConfig200ResponseShipmentProvidersFromJSON(json['shipmentProviders']),
        'manualShipment': json['manualShipment'] == null ? undefined : json['manualShipment'],
        'lastProducts': GetConfig200ResponseLastProductsFromJSON(json['lastProducts']),
        'lastProductPosEnabled': json['lastProductPosEnabled'] == null ? undefined : json['lastProductPosEnabled'],
        'lastProductBookingsEnabled': json['lastProductBookingsEnabled'] == null ? undefined : json['lastProductBookingsEnabled'],
        'lastProductAttendanceEnabled': json['lastProductAttendanceEnabled'] == null ? undefined : json['lastProductAttendanceEnabled'],
        'lastProductStockEnabled': json['lastProductStockEnabled'] == null ? undefined : json['lastProductStockEnabled'],
        'waitForMetaBeforePrintingBill': json['waitForMetaBeforePrintingBill'],
        'adyenDataphones': ((json['adyenDataphones'] as Array<any>).map(GetConfig200ResponseAdyenDataphonesInnerFromJSON)),
        'kassensichvInfo': GetConfig200ResponseKassensichvInfoFromJSON(json['kassensichvInfo']),
        'taxRate': GetConfig200ResponseTaxRateFromJSON(json['taxRate']),
    };
}

export function GetConfig200ResponseToJSON(json: any): GetConfig200Response {
    return GetConfig200ResponseToJSONTyped(json, false);
}

export function GetConfig200ResponseToJSONTyped(value?: GetConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationName': value['locationName'],
        'locationAddress': value['locationAddress'],
        'locationPhoneNumber': value['locationPhoneNumber'],
        'locationCountryCode': value['locationCountryCode'],
        'currencyCode': value['currencyCode'],
        'billCopies': value['billCopies'],
        'timeoutSeconds': value['timeoutSeconds'],
        'workingTime': GetConfig200ResponseWorkingTimeToJSON(value['workingTime']),
        'autoprintBills': value['autoprintBills'],
        'autoprintKitchenOrders': value['autoprintKitchenOrders'],
        'autoprintReceipts': value['autoprintReceipts'],
        'language': value['language'],
        'defaultKitchenPrinter': value['defaultKitchenPrinter'],
        'defaultBillPrinter': value['defaultBillPrinter'],
        'controlPrinter': value['controlPrinter'],
        'onlyMasterPrinting': value['onlyMasterPrinting'],
        'enableKitchenOrders': value['enableKitchenOrders'],
        'showTakeAwayTabPopup': value['showTakeAwayTabPopup'],
        'showProductImages': value['showProductImages'],
        'blindTill': value['blindTill'],
        'locationBrandId': value['locationBrandId'],
        'tabOrdering': value['tabOrdering'],
        'autoprintQrKitchenOrders': value['autoprintQrKitchenOrders'],
        'legalEntityId': value['legalEntityId'],
        'fastMode': value['fastMode'],
        'fastModeHome': value['fastModeHome'],
        'fastModeTakeaway': value['fastModeTakeaway'],
        'ticketInfo': value['ticketInfo'],
        'googlePlaceId': value['googlePlaceId'],
        'showLanguageSelector': value['showLanguageSelector'],
        'restaurantAutoprint': value['restaurantAutoprint'],
        'takeawayAutoprint': value['takeawayAutoprint'],
        'printers': ((value['printers'] as Array<any>).map(GetConfig200ResponsePrintersInnerToJSON)),
        'tills': GetConfig200ResponseTillsToJSON(value['tills']),
        'cashTills': ((value['cashTills'] as Array<any>).map(GetConfig200ResponseTillsCashInnerToJSON)),
        'paymentMethods': value['paymentMethods'],
        'paymentMethodsConfig': ((value['paymentMethodsConfig'] as Array<any>).map(GetConfig200ResponsePaymentMethodsConfigInnerToJSON)),
        'dataphoneConfigs': ((value['dataphoneConfigs'] as Array<any>).map(GetConfig200ResponseDataphoneConfigsInnerToJSON)),
        'terminals': ((value['terminals'] as Array<any>).map(GetConfig200ResponseTerminalsInnerToJSON)),
        'isHotel': value['isHotel'],
        'legalEntity': GetConfig200ResponseLegalEntityToJSON(value['legalEntity']),
        'company': GetConfig200ResponseCompanyToJSON(value['company']),
        'employees': GetConfig200ResponseEmployeesToJSON(value['employees']),
        'virtualBrands': ((value['virtualBrands'] as Array<any>).map(GetConfig200ResponseVirtualBrandsInnerToJSON)),
        'reservations': GetConfig200ResponseReservationsToJSON(value['reservations']),
        'reservationDurations': GetConfig200ResponseReservationDurationsToJSON(value['reservationDurations']),
        'organizationConfig': GetConfig200ResponseOrganizationConfigToJSON(value['organizationConfig']),
        'preparationMinutes': value['preparationMinutes'],
        'schedulingMarginMinutes': value['schedulingMarginMinutes'],
        'deliveryTillId': value['deliveryTillId'],
        'deliveryPrinterId': value['deliveryPrinterId'],
        'shipmentProvider': value['shipmentProvider'],
        'shipmentProviders': GetConfig200ResponseShipmentProvidersToJSON(value['shipmentProviders']),
        'manualShipment': value['manualShipment'],
        'lastProducts': GetConfig200ResponseLastProductsToJSON(value['lastProducts']),
        'lastProductPosEnabled': value['lastProductPosEnabled'],
        'lastProductBookingsEnabled': value['lastProductBookingsEnabled'],
        'lastProductAttendanceEnabled': value['lastProductAttendanceEnabled'],
        'lastProductStockEnabled': value['lastProductStockEnabled'],
        'waitForMetaBeforePrintingBill': value['waitForMetaBeforePrintingBill'],
        'adyenDataphones': ((value['adyenDataphones'] as Array<any>).map(GetConfig200ResponseAdyenDataphonesInnerToJSON)),
        'kassensichvInfo': GetConfig200ResponseKassensichvInfoToJSON(value['kassensichvInfo']),
        'taxRate': GetConfig200ResponseTaxRateToJSON(value['taxRate']),
    };
}

